/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FileService {
    /**
     * @param fileId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiV1Files(
        fileId: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/files/{fileId}',
            path: {
                'fileId': fileId,
            },
        });
    }
    /**
     * @param fileId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiV1FilesPreview(
        fileId: ConvertDatesToStrings<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/files/{fileId}/preview',
            path: {
                'fileId': fileId,
            },
        });
    }
}
